module.exports = __webpack_public_path__ + "img/ny-bannar1.9b361b06.jpg";